import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tile-steal-from-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_player_picture = _resolveComponent("player-picture")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tile", _ctx.className]),
    style: _normalizeStyle(_ctx.tile.style),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick()))
  }, [
    (_ctx.tile.number)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["tile-number", `tile-number-${_ctx.probability}`])
        }, _toDisplayString(_ctx.tile.number), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["tile-thief", { movable: _ctx.canMoveThief && !_ctx.movingThief }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleThiefClick()))
    }, null, 2),
    (_ctx.recievingThief)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidatePlayersToStealFrom, (playerId) => {
            return (_openBlock(), _createBlock(_component_player_picture, {
              key: playerId,
              "player-id": playerId,
              onClick: ($event: any) => (_ctx.recieveThief(playerId))
            }, null, 8, ["player-id", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 6))
}